import ReactDOM from 'react-dom'

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'
import './style.css'
import Home from './views/home'
import ProductGallery from './views/product-gallery'
import InquiryCustomOrder from './views/inquiry-custom-order'
import NotFound from './views/not-found'
import AboutUs from './views/about-us'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={ProductGallery} exact path="/product-gallery" />
        <Route
          component={InquiryCustomOrder}
          exact
          path="/inquiry-custom-order"
        />
        <Route exact path="/about-us" component={AboutUs} />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
